<template>
  <div class="websites">
    <v-data-table
      dense
      :headers="headers"
      :items="desserts"
      :search="search"
      :items-per-page="1000"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Веб сайты</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="dialog = true"
            ><v-icon left>add</v-icon>Добавить веб сайт</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small @click="editItem(item)"> edit </v-icon>
        <v-icon small @click="deleteItem(item)"> delete </v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title style="justify-content: center">
          Добавить веб сайт
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="addedWebsite"
            clearable
            label="веб сайт: site.ru"
            single-line
            hide-details
          />
        </v-card-text>
        <v-card-actions style="justify-content: space-around">
          <v-btn color="primary" text @click="dialog = false"> Закрыть </v-btn>
          <v-btn color="success" dark @click="AddSite" v-if="!editable">
            Добавить
          </v-btn>
          <v-btn color="success" dark @click="editSite" v-else>
            Сохранить изменения
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>
  </div>
</template>
<script>
export default {
  name: "websites",
  components: {},
  data: () => ({
    headers: [
      {
        text: "id",
        align: "left",
        sortable: true,
        value: "id",
        width: '100'
      },
      {
        text: "Название",
        align: "left",
        sortable: true,
        value: "name",
      },
      { text: "Действия", value: "action", sortable: false, align: "center", width: '30'},
    ],
    search: "",
    loading: false,
    dialog: false,
    editable: false,
    editItemsInfo: null,

    addedWebsite: "",
    addDisabled: false,
  }),
  methods: {
    async init(){
      await this.$store.dispatch("getAllWebsite");
      this.dialog = false;
      this.editable = false
      this.editItemsInfo = null
      this.addedWebsite = "";
    },
    async AddSite() {
      await this.$store.dispatch("addWebsite", this.addedWebsite);
      this.init()
    },
    async editSite(){
      this.editItemsInfo.name = this.addedWebsite
      await this.$store.dispatch('editWebsite',this.editItemsInfo)
      this.init()
    },
    deleteItem(item){
      this.$store.dispatch('removeWebsite',item.id)
    },
    editItem(item){
      this.editable = true
      this.dialog = true
      this.addedWebsite = item.name
      this.editItemsInfo = item
    }
  },
  computed: {
    desserts() {
      const arr = Object.assign([],this.$store.getters.getWebsites)
      return arr.sort((a,b)=>a.name < b.name ? -1 : 1);
    },
  },
  watch: {
    addedWebsite() {
      // const reg = /.+\..+/;
      // if (reg.test(this.addedWebsite)) {
      //   this.addDisabled = false;
      // } else {
      //   this.addDisabled = true;
      // }
      this.addDisabled = false
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
